<!--
/**
 * SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
 * Copyright (C) 2025 SuiteCRM Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */
-->
<div [class.uploaded-file]="!compact"
     [class.uploaded-file-compact]="compact"
     [style.min-width]="minWidth"
     class="uploaded-file-wrapper"
>
    <div [class.d-flex]="compact"
         [class.flex-grow-1]="compact"
         class="uploaded-file-info-wrapper"
    >
        <div class="uploaded-file-info-container"
             [class.uploaded-file-error]="file?.status() === 'error'">
            <div class="uploaded-file-icon-container">
                <div *ngIf="file?.status() === 'saved'">
                    <scrm-image [image]="savedIcon" class="uploaded-file-icon"></scrm-image>
                </div>
                <div *ngIf="file?.status() === 'uploading'">
                    <scrm-image [image]="uploadingIcon" class="uploaded-file-icon"></scrm-image>
                </div>
                <div *ngIf="file?.status() === 'uploaded'" @scaleInOut>
                    <scrm-image [image]="uploadedIcon" class="uploaded-file-icon"></scrm-image>
                </div>
                <div *ngIf="file?.status() === 'error'" @scaleInOut>
                    <scrm-image [image]="errorIcon"
                                class="uploaded-file-icon uploaded-file-icon-error"></scrm-image>
                </div>
            </div>
            <div class="uploaded-file-info">
                <a [href]="file?.contentUrl" download class="d-flex pr-1 clickable" [style.max-width]="textMaxWidth()" target="_blank">
                    <span class="uploaded-file-name" [title]="file?.name">
                        {{ file?.name }}
                    </span>
                </a>
                <span *ngIf="displaySize" class="uploaded-file-size" [style.max-width]="textMaxWidth()">
                    ({{ file?.size | fileSize }})
                </span>
                <div *ngIf="file?.status() === 'error'">
                    <span *ngIf="file?.errorMessage()" class="text-error text-smaller-95">
                        <scrm-label [labelKey]="file?.errorMessage()"></scrm-label>
                    </span>
                    <span *ngIf="!file?.errorMessage()" class="text-error text-smaller-95">
                        <scrm-label labelKey="LBL_UPLOAD_FAILED"></scrm-label>
                    </span>
                </div>
            </div>
        </div>
        <div class="w-100" *ngIf="file?.status() === 'uploading'">
            <div class="upload-progress-bar">
                <div class="upload-progress-bar-fill" [style.width.%]="file.progress()"></div>
            </div>
        </div>
    </div>
    <div class="uploaded-file-actions">
        <ng-container *ngIf="allowClear">
            <scrm-button *ngIf="file?.status() !== 'error'" [config]="clearButtonConfig">
            </scrm-button>
            <scrm-button *ngIf="file?.status() === 'error'" [config]="errorClearButtonConfig">
            </scrm-button>
        </ng-container>
    </div>
</div>
